// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@gcg/XDL/types";
import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            a,
            button,
            span {
                color: ${getColor("text.main")} !important;
                letter-spacing: 0.5px;
            }
        `,
        typographyProps: {
            size: 14,
            color: "text.main",
        },
    },
} as xBaseTheme["breadcrumbs"];

// 3 dots menu style
export const breadcrumbsMenuStyle: MenuPresentationProps = {
    cssOverrides: {
        wrapper: css`
            flex: 0 1 auto;
            min-width: 0;
            &::after {
                content: "";
                position: absolute;
                top: 11.5px;
                left: 6px;
                margin-left: -10px;
                border-width: 10px;
                border-style: solid;
                border-color: transparent transparent #ffffff transparent;
                z-index: 1355;
            }

            ul {
                padding: 5px;
                a:hover {
                    background: ${getColor("common.ui3")};
                }
            }
        `,
        menu: css`
            left: -30px;
            top: 30px;
            width: 181px;
            border-radius: 0;
            background-color: #ffffff;
            box-shadow: 0 0 15px 0 rgba(80, 106, 113, 0.25);
        `,
    },
};
